// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"419":"c8d19df7","942":"d6db03ca"}[chunkId] + ".chunk.js";
};